import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import {
  Button,
  Modal,
  ButtonToolbar,
  Clearfix,
} from 'react-bootstrap';

const propTypes = exact({
  showModal: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  confirm: PropTypes.func.isRequired,
  disable: PropTypes.bool.isRequired,
});


const ConfirmSplitModal = (props) => {
  const {
    showModal,
    onHide,
    confirm,
    disable,
  } = props;

  return (
    <Modal show={showModal} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Confirm Split</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Clearfix>
          <p> Splitting a pdf is not reversable. Are you sure you want to split the pdf?</p>
          {disable && (
            <div>
              <span className="glyphicon glyphicon-refresh spinning" /> Loading...
            </div>
          )}
          <ButtonToolbar className="pull-right">
            <Button disabled={disable} onClick={onHide}>Cancel</Button>
            <Button disabled={disable} onClick={confirm} className="btn btn-danger">Split</Button>
          </ButtonToolbar>
        </Clearfix>
      </Modal.Body>
    </Modal>
  );
};


ConfirmSplitModal.propTypes = propTypes;


export default ConfirmSplitModal;
